import { render, staticRenderFns } from "./HerstellerKundenumsaetzeReiter.vue?vue&type=template&id=347139c4&"
import script from "./HerstellerKundenumsaetzeReiter.vue?vue&type=script&lang=js&"
export * from "./HerstellerKundenumsaetzeReiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports